import clsx from "clsx";
import Image from "next/image";
import { FC, useRef, useState } from "react";
import { useSearchBox } from "react-instantsearch";
import { SearchHits } from "../SearchHits/SearchHits";
import { SearchIcon } from "../SearchIcon/SearchIcon";
import { SearchBox } from "./SearchBox/SearchBox";

export const MobileSearch: FC = () => {
  const [isShow, setIsShow] = useState(false);
  const { refine } = useSearchBox();
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="ml-auto md:hidden">
      {isShow ? (
        <Image
          src="/images/close.svg"
          onClick={() => {
            setIsShow(false);
          }}
          width={32}
          height={32}
          className="cursor-pointer"
          alt=""
        />
      ) : (
        <SearchIcon
          fill="#fff"
          onClick={() => {
            refine("");
            setIsShow(true);
            setTimeout(() => {
              inputRef.current?.focus();
            });
          }}
        />
      )}

      <div
        className={clsx(
          isShow ? "block" : "hidden",
          "fixed left-0 top-[57px] flex h-[calc(100vh-57px)] w-screen flex-col gap-4 rounded-2xl bg-[#EEE] p-4",
        )}
      >
        <SearchBox inputRef={inputRef} onChange={(value) => refine(value)} className="border-none bg-white" />
        <SearchHits className="overflow-y-auto rounded-lg bg-white px-4" setIsShow={setIsShow} isMobile />
      </div>
    </div>
  );
};
